var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKredi = function SvgKredi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.23 6.242c0-.35-.137-.685-.38-.933a1.29 1.29 0 0 0-.919-.386h-3.897c0 1.399.547 2.74 1.522 3.73a5.158 5.158 0 0 0 3.674 1.545V6.242ZM1.846 10.198c1.378 0 2.7-.556 3.674-1.545a5.315 5.315 0 0 0 1.522-3.73H3.145a1.29 1.29 0 0 0-.919.386c-.243.248-.38.583-.38.933v3.956ZM25.23 18.11c-1.378 0-2.7.556-3.674 1.545a5.315 5.315 0 0 0-1.522 3.73h3.897c.345 0 .675-.14.919-.387.243-.247.38-.582.38-.932V18.11ZM1.846 22.066c0 .35.137.685.38.932.244.248.574.387.919.387h3.897c0-1.4-.547-2.741-1.522-3.73a5.158 5.158 0 0 0-3.674-1.545v3.956Z",
    stroke: "#F26722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.931 4.923H3.145c-.718 0-1.3.59-1.3 1.319v15.824c0 .728.582 1.319 1.3 1.319H23.93c.718 0 1.3-.59 1.3-1.319V6.242c0-.729-.582-1.319-1.3-1.319Z",
    stroke: "#5D5BEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.615 14.21a.382.382 0 0 0-.365-.38h-.193a.367.367 0 0 0-.366.34c-.02.225-.05.451-.111.667a3.595 3.595 0 0 1-1.198 1.848 3.499 3.499 0 0 1-1.867.81V13.513c.02-.02.05-.03.081-.051l2.517-.914a.278.278 0 0 0 .183-.267v-.123a.285.285 0 0 0-.285-.287c-.03 0-.06.01-.09.02l-.894.339-1.512.544v-.39l2.608-.955a.292.292 0 0 0 .183-.267v-.144a.29.29 0 0 0-.284-.277c-.03 0-.072.01-.102.02l-2.405.883V9.611a.377.377 0 0 0-.376-.38h-.182a.373.373 0 0 0-.366.37v2.371l-1.552.555a.287.287 0 0 0-.193.266v.154a.29.29 0 0 0 .284.278c.03 0 .06-.01.091-.021l.751-.277c.04-.01.132-.041.274-.093.142-.05.254-.102.345-.143v.41l-1.542.565a.29.29 0 0 0-.193.277v.144a.281.281 0 0 0 .386.246l1.197-.43.152-.062v4.24c0 .205.163.38.376.38h.02a4.244 4.244 0 0 0 1.675-.298 4.548 4.548 0 0 0 1.38-.842 4.28 4.28 0 0 0 1.045-1.335 4.381 4.381 0 0 0 .518-1.694c.01-.02.01-.04.01-.082Z",
    fill: "#F26722",
    stroke: "#F26722"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.615 27.692h20.193a1.348 1.348 0 0 0 1.346-1.342V12.923",
    stroke: "#5D5BEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgKredi;